// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceLightningBoltThin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.418 11.35c.183-.296-.022-.684-.361-.684h-3.422l1.184-6.132c.093-.483-.527-.741-.783-.327L6.823 12.65c-.183.296.022.684.361.684h3.421l-1.183 6.132c-.093.482.526.741.782.327zm-.361-2.684c1.864 0 2.991 2.135 1.986 3.762l-5.213 8.443c-1.407 2.277-4.812.854-4.3-1.797l.721-3.74H7.184c-1.864 0-2.992-2.135-1.987-3.762l5.214-8.443c1.406-2.277 4.811-.854 4.3 1.797l-.722 3.74z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceLightningBoltThin;
